import { InputBoxSingle } from '@peacecover/component';

type GradientBodyBoxProps = {
  title: string;
  description?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
} & React.ComponentProps<typeof InputBoxSingle>;

const GradientBodyBox = ({
  title,
  description,
  placeholder,
  value,
  onChange,
  className,
  ...props
}: GradientBodyBoxProps) => {
  return (
    <div className={`relative rounded-[18px] p-[2px] ${className}`}>
      <div className="absolute inset-0 rounded-[18px] bg-[linear-gradient(136deg,#15CCCB_1.21%,#4987FF_50.69%,#8B1CFA_101.7%)]" />
      <div className="flex flex-col gap-[20px] relative rounded-[16px] bg-background-light dark:bg-background-dark px-[20px] py-[24px]">
        <div className="flex flex-col gap-[8px] text-center">
          <p className="text-[17px] leading-[20px] font-bold text-text-main-lv2">{title}</p>
          {description && (
            <p className="text-[13px] leading-[16px] text-text-main-lv3">{description}</p>
          )}
        </div>
        <InputBoxSingle
          className="bg-transparent border-none"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...props}
        />
      </div>
    </div>
  );
};

export default GradientBodyBox;
